import { Translation } from "@/shared/i18n";
import { createContext } from "react";

//@ts-expect-error from server
export const I18nContext = createContext<Translation>();
